export { getProviderName, type GetProviderNameArgs } from './getProviderName';
